import { useGame } from "../context/GameContext";
import { useMultiplayer } from "../context/MultiplayerContext";
import { MULTIPLAYER } from "../utils/constants";

export default function useUtils() {
    const { setMultiplayerState } = useMultiplayer();
    const { setGameState } = useGame();

    const checkForMultiplayer = () => {
        const search = new URLSearchParams(window.location.search);
        if (!search.has(MULTIPLAYER.LOBBY_ID_KEY)) return;

        const lobbyId = search.get(MULTIPLAYER.LOBBY_ID_KEY);
        if (!lobbyId) return;

        setMultiplayerState((prev) => ({
            ...prev,
            showUserNamePage: true,
            lobbyId,
        }));

        setGameState((prev) => ({
            ...prev,
            game: null,
            isAIGame: false,
            showGame: false,
        }));
    };

    return {
        checkForMultiplayer,
    };
}
